/** The nine body measurements, in the order the list shows them. */
export const METRICS = [
  'body_weight',
  'body_fat',
  'waist',
  'chest',
  'hips',
  'arm_left',
  'arm_right',
  'thigh_left',
  'thigh_right',
] as const;
export type Metric = (typeof METRICS)[number];

/** The metrics the client has recorded, in the list's order. */
export function trackedMetrics(available: string[]): Metric[] {
  return METRICS.filter((metric) => available.includes(metric));
}
